import { Modal } from "@/app/(components)/Basic/Modal";
import React from "react";
import { ArtOrderFull, ArtOrderOffer } from "@/api/art-order/types";
import { ExtendOrderForm } from "../ExtendOrderForm";

export interface Props {
  isOpen: boolean;
  handleClose: () => void;
  onSuccess: () => void;
  artOrder: ArtOrderFull;
  acceptedOffer: ArtOrderOffer;
}

const ExtendOrderModal = ({
  isOpen,
  handleClose,
  onSuccess,
  artOrder,
  acceptedOffer,
}: Props) => {
  return (
    <div>
      <Modal
        isOpen={isOpen}
        hasCloseButton
        onClose={handleClose}
        className="w-full max-w-[530px]"
      >
        <div className=" text-center">
          <h3 className="font-semibold mb-6">Extend an order</h3>
          <div className="text-body-2 mb-6">
            Please enter the details of your order.
          </div>
        </div>
        <ExtendOrderForm
          onSuccess={onSuccess}
          artOrder={artOrder}
          acceptedOffer={acceptedOffer}
        />
      </Modal>
    </div>
  );
};

export default ExtendOrderModal;
